import React from 'react'
import { Tab, Nav } from 'react-bootstrap'
import { LOTTERY_COUNT_TABS } from './constant'

const TabStatus = ({ handleChangeTabStatus, tabSelected }) => {
  return (
    <Tab.Container defaultActiveKey={LOTTERY_COUNT_TABS[0].value}>
      <Nav as="ul" className="nav-pills mb-4 light">
        {LOTTERY_COUNT_TABS.map((data, i) => {
          return (
            i !== LOTTERY_COUNT_TABS.length && (
              <Nav.Item as="li" key={i}>
                <Nav.Link
                  className={tabSelected === data.value ? 'active' : ''}
                  onClick={() => handleChangeTabStatus(data.value)}
                >
                  {data.title}
                </Nav.Link>
              </Nav.Item>
            )
          )
        })}
      </Nav>
    </Tab.Container>
  )
}

export default TabStatus
